import React from 'react'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

import styled from 'styled-components'
import CustomTooltip from '../../components/CustomTooltip'

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
`

export const DayPickerContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const TextContainer = styled.div`
  text-transform: none;
`

export const TodayButton = withStyles({
  root: {
    textTransform: 'none',
    fontSize: 12,
  },
})(props => <Button variant="text" color="primary" {...props} />)

export const MissingButton = withStyles({
  root: {
    textTransform: 'none',
    fontSize: 12,
  },
})(props => (
  <CustomTooltip title="Go to earliest missing timesheet">
    <Button variant="text" color="secondary" {...props} />
  </CustomTooltip>
))

export const LoadingIndicator = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
`

export const CalendarContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  padding: 10px;
`

export const CalendarWrapper = styled.div`
  display: flex;
  gap: 1rem;
  height: 100%;
  width: 100%;
  flex: 1;
`

export const StyledControlsContainer = styled.div`
  margin-top: 3rem;
  gap: 0.75rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;
  position: relative;
  border-right: 1px solid #e0e0e0;
`

export const StyledCollapseToggleButton = styled.button`
  position: absolute;
  top: 5rem;
  right: 0;
  transform: translate(50%, -50%);
  width: 30px;
  height: 30px;
  border: 1px solid #c7c7c7;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  }

  svg {
    font-size: 20px;
    color: #666;
  }
`

export const StyledCollapsedSidebar = styled.div`
  margin-top: 3rem;
  width: 2rem;
  min-width: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0.5rem;
  position: relative;
  border-right: 1px solid #e0e0e0;
`

export const SidebarTabsBox = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`

export const SidebarTabsHeader = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: #f7f7f9;
  border-bottom: 1px solid #e0e0e0;
`

export const SidebarTabButton = styled.button`
  flex: 1;
  border: none;
  background-color: ${({ active }) => (active ? '#ffffff' : 'transparent')};
  color: ${({ active }) => (active ? '#333333' : '#666666')};
  font-size: 0.8rem;
  font-weight: 600;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: ${({ active }) => (active ? '0 1px 2px rgba(0, 0, 0, 0.12)' : 'none')};
  transition: all 0.2s ease;

  &:hover {
    background-color: #ffffff;
    color: #333333;
  }
`

export const SidebarTabsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem 0;
`

export const ProjectSummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`

export const ProjectSummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-radius: 6px;
  background-color: #f7f7f9;
  color: #050519;
`

export const ProjectSummaryName = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: #050519;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70%;
`

export const ProjectSummaryValue = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: #333333;
  white-space: nowrap;
`

export const ProjectSummaryEmpty = styled.div`
  font-size: 0.8rem;
  color: #666666;
  text-align: center;
  padding: 0.5rem 0;
`

export const GeneralButton = styled(Button)`
  ${({ clickable = true }) => `
    cursor: ${clickable ? 'pointer' : 'default'};
  `}

  font-size: 0.8125rem;
  width: 100%;
  padding: 10px 16px;
  border-radius: 6px;
  background-color: ${({ bgColor }) => bgColor || 'rgb(88, 86, 255)'};
  color: ${({ color }) => color || '#ffffff'};
  height: fit-content;
  font-weight: 500;
  text-transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  border: none;

  &:hover {
    background-color: ${({ hoverBgColor }) => hoverBgColor || 'rgb(88, 86, 255)'};
    color: ${({ hoverColor }) => hoverColor || '#ffffff'};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`
